<ng-container [ngSwitch]="grouped">
  <ng-container *ngSwitchCase="true">
    <div *ngFor="let i of 2 | fill" class="grouped-section">
      <div class="placeholder-header shimmer"></div>

      <ul class="placeholder-contents">
        <li *ngFor="let i of 3 | fill" class="placeholder-item">
          <div
            *ngFor="let i of 3 | fill; let col = index"
            class="item col-{{ col + 1 }}"
          >
            <div class="shimmer"></div>
          </div>
        </li>
      </ul>
    </div>
  </ng-container>

  <ng-container *ngSwitchDefault>
    <ul class="placeholder-contents">
      <li *ngFor="let i of 5 | fill" class="placeholder-item">
        <div
          *ngFor="let i of 3 | fill; let col = index"
          class="item col-{{ col + 1 }}"
        >
          <div class="shimmer"></div>
        </div>
      </li>
    </ul>
  </ng-container>
</ng-container>
